const paths = {
  listCustomer: '/customer/list'
};

export default paths;
